import React from 'react';
export default function Input({ value, onChange, type = 'default' }) {
  return <input style={styles.input} value={value} onChange={(e) => onChange(e.target.value)} type={type} />;
}
const styles = {
  input: {
    width: 300,
    padding: 10,
    fontSize: 28,
    textAlign: 'center',
  },
};
